import { Button, Flex } from "@radix-ui/themes";
import { AlertIcon } from "@/public/index";

export default function SaveButton({ save, disabled, advancedSetting }: { save: () => void; disabled?: boolean; advancedSetting?: boolean }) {
    return (
        <Flex direction="row" gap="1">
            <Button
                tabIndex={0}
                onClick={save}
                data-testid="save-call-features-button"
                style={{ zIndex: 100 }}
                className="cursor-pointer  bg-att-cobalt-blue text-white px-6 py-3 h-11 rounded-[32px] disabled:bg-att-gray disabled:cursor-default "
                disabled={disabled}>
                {advancedSetting ? <AlertIcon /> : null}
                Save changes
            </Button>
        </Flex>
    );
}
